import { notificationPost } from '../api/notificationClient';
export default async (notificationData, logger) => {
    return notificationPost(notificationData, '/msg/api/notification', {}, logger);
};
